
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';

import Layout from 'components/Dashboard/Layout';
import { ListProvider, ListContext } from 'core/ListProvider';
import SearchWidget from 'form/SearchWidget';
import { TimetableListTable } from './ListTable';
import { TimetableListFilter } from './ListFilter';
import TableStickyHeader from 'core/TableStickyHeader';
import Fuse from "fuse.js";
import OrderDetail from 'components/Order/Detail';
import { Drawer } from 'ui/Drawer';


export default class TimetableList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchPhrase: ''
    }
  }

  componentDidMount() {
    document.title = 'Статус ТС';
  }

  searchItems = (items, phrase) => {
    if (!phrase)
      return items;

    const options = {
      includeScore: true,
      threshold: 0.1,
      shouldSort: false,
      keys: [
        'info.driver.last_name',
        'info.tractor_unit.number',
        'info.semi_trailer.number'
      ]
    };

    let searchResults = [];
    let fuse = new Fuse(items, options);
    fuse.search(phrase).forEach(el => searchResults.push(el.item));
    return searchResults;
  };

  onChangeSearchValue = (value) => {
    this.setState({searchPhrase: value})
  }

  getPreviewId = () => {
    const match = this.props.location.pathname.match(/\/preview\/(\d+)/);
    return match ? match[1] : undefined;
  };

  openPreview = (order) => {
    this.props.history.push(`/timetable/preview/${order.id}`);
  };

  closePreview = () => {
    this.props.history.push('/timetable');
  };

  render() {
    const previewId = this.getPreviewId();
    return (
      <ListProvider
        url={'timetable_slot/grouped'}
      >
        <ListContext.Consumer>
          {context => {
            const { items, response, loading } = context;
            const searchedItems = this.searchItems(items, this.state.searchPhrase);

            return (
              <Layout>

                <Layout.Header
                  title={'Статус ТС'}
                  search={
                    <SearchWidget
                      value={this.state.searchPhrase}
                      onChange={(value) => this.onChangeSearchValue(value)}
                    />
                  }
                />

                <Layout.Filter>
                  <TimetableListFilter context={context} />
                </Layout.Filter>

                <Layout.ContentSimple>
                  {(response && response.dates) && (
                    <Paper>
                      <TableStickyHeader subtractHeight={205}>
                        <TimetableListTable
                          items={searchedItems}
                          dates={response.dates}
                          loading={loading}
                          onChangeSearchValue={this.onChangeSearchValue}
                          previewId={previewId}
                          onPreview={this.openPreview}
                          fromPath={this.props.location.pathname}
                        />
                      </TableStickyHeader>
                    </Paper>
                  )}
                </Layout.ContentSimple>

                <Drawer
                  open={!!previewId}
                  onClose={this.closePreview}
                  width={'450px'}
                  disableEscapeKeyDown={true}
                >
                  <OrderDetail
                    id={previewId}
                    onClose={this.closePreview}
                    fromPath={`/timetable/preview/${previewId}`}
                  />
                </Drawer>

              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
